import React from 'react';
import { A11y, Pagination } from 'swiper';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.min.css';
import { useWindowSize } from 'usehooks-ts';

import QuoteIcon from 'images/subscription_landing/quote.svg';

import { CommentUser } from '../../utils/backend-api/comments';
import { WIDTH_SM } from '../../utils/constants';
import CommentAvatar from '../Comments/CommentAvatar';
import styles from './styles.module.scss';

export interface Testimonial {
  user: CommentUser;
  testimony: string;
}

const TestimonialCard = ({ testimonial: { user, testimony } }: { testimonial: Testimonial }) => (
  <div className={styles.testimonialCard}>
    <img src={QuoteIcon} alt="" />
    <div>{testimony}</div>
    <div className={styles.profile}>
      <CommentAvatar user={user} />
      <div>
        <div className={styles.profileName}>{user.name}</div>
        <div className={styles.profileDetails}>
          {user.title_at_company}, {user.company_name}
        </div>
      </div>
    </div>
  </div>
);

const TestimonialsSection = ({ testimonials }: { testimonials: Testimonial[] }) => {
  const { width } = useWindowSize();

  return (
    <div className={styles.testimonialsSection}>
      <div className={styles.testimonialsContainer}>
        <h6 className={styles.sectionHeader}>What Subscribers are Saying</h6>
        <Swiper
          modules={[A11y, Pagination]}
          spaceBetween={10}
          slidesPerGroup={width > WIDTH_SM ? 3 : 1}
          slidesPerView={width > WIDTH_SM ? 3 : 1}
          pagination={{ clickable: true }}
        >
          {testimonials.map((testimonial, idx) => (
            <SwiperSlide key={idx}>
              <TestimonialCard testimonial={testimonial} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default TestimonialsSection;
